export default __webpack_public_path__ + "static/edu-5e273ed623a3fc71b135d172b1468637.png";